
import {  useRef, useState } from 'react';
import './recargas.css';
import Alert from '@mui/material/Alert';
import Backdrop from '@mui/material/Backdrop';

const ofertas = [
    {
        id:1,
        monto: 10,
        vigencia:"1 día",
        incluye1:"100 MB de internet",
        incluye2:"",
        promocion:"100MB",
        total:"200 MB",
        imagenPromo:"",
        imagenRedes:"https://www.att.com.mx/on/demandware.static/-/Sites-att-Library/default/dwe9628000/images/servicios/recargas/rrss@2x.png"
    },
    {
        id:3,
        monto: 20,
        vigencia:"1 día",
        incluye1:"200 MB de internet",
        incluye2:"",
        promocion:"200MB",
        total:"400 MB",
        imagenPromo:"",
        imagenRedes:"https://www.att.com.mx/on/demandware.static/-/Sites-att-Library/default/dwe9628000/images/servicios/recargas/rrss@2x.png"
    },
    {
        id:4,
        monto: 30,
        vigencia:"3 días",
        incluye1:"300 MB de internet",
        incluye2:"",
        promocion:"300MB",
        total:"600 MB",
        imagenPromo:"",
        imagenRedes:"https://www.att.com.mx/on/demandware.static/-/Sites-att-Library/default/dwe9628000/images/servicios/recargas/rrss@2x.png"
    },
    {
        id:5,
        monto: 50,
        vigencia:"5 días",
        incluye1:"500 MB de internet",
        incluye2:"",
        promocion:"500MB",
        total:"1 GB",
        imagenPromo:"",
        imagenRedes:"https://www.att.com.mx/on/demandware.static/-/Sites-att-Library/default/dwe9628000/images/servicios/recargas/rrss@2x.png"
    },
    {
        id:6,
        monto: 70,
        vigencia:"7 días",
        incluye1:"700 MB de internet",
        incluye2:"",
        promocion:"700MB",
        total:"1.4 GB",
        imagenPromo:"",
        imagenRedes:"https://www.att.com.mx/on/demandware.static/-/Sites-att-Library/default/dwe9628000/images/servicios/recargas/rrss@2x.png"
    },
    {
        id:7,
        monto: 100,
        vigencia:"14 días",
        incluye1:"1.5 GB de internet",
        incluye2:"+0.75 GB para video",
        promocion:"1.5 GB",
        total:"3.75 GB",
        imagenPromo:"https://www.att.com.mx/on/demandware.static/-/Sites-att-Library/default/dw85255366/images/servicios/recargas/recarga-apps-video.svg",
        imagenRedes:"https://www.att.com.mx/on/demandware.static/-/Sites-att-Library/default/dwe9628000/images/servicios/recargas/rrss@2x.png"
    },
    {
        id:8,
        monto: 150,
        vigencia:"25 días",
        incluye1:"2.3 GB de internet",
        incluye2:"+1.15 GB para video",
        promocion:"2.3 GB",
        total:"5.75 GB",
        imagenPromo:"https://www.att.com.mx/on/demandware.static/-/Sites-att-Library/default/dw85255366/images/servicios/recargas/recarga-apps-video.svg",
        imagenRedes:"https://www.att.com.mx/on/demandware.static/-/Sites-att-Library/default/dwe9628000/images/servicios/recargas/rrss@2x.png"
    },
    {
        id:9,
        monto: 200,
        vigencia:"25 días",
        incluye1:"2.3 GB de internet",
        incluye2:"+1.15 GB para video",
        promocion:"2.3 GB",
        total:"5.75 GB",
        imagenPromo:"https://www.att.com.mx/on/demandware.static/-/Sites-att-Library/default/dw85255366/images/servicios/recargas/recarga-apps-video.svg",
        imagenRedes:"https://www.att.com.mx/on/demandware.static/-/Sites-att-Library/default/dwe9628000/images/servicios/recargas/rrss@2x.png"
    },
    {
        id:10,
        monto: 300,
        vigencia:"25 días",
        incluye1:"2.3 GB de internet",
        incluye2:"+1.15 GB para video",
        promocion:"2.3 GB",
        total:"5.75 GB",
        imagenPromo:"https://www.att.com.mx/on/demandware.static/-/Sites-att-Library/default/dw85255366/images/servicios/recargas/recarga-apps-video.svg",
        imagenRedes:"https://www.att.com.mx/on/demandware.static/-/Sites-att-Library/default/dwe9628000/images/servicios/recargas/rrss@2x.png"
    },
];


export const Beneficios = () => {

    const refTexto = useRef('incorrecto');


const [open, setOpen] = useState(false);
const [isActive, setIsActive] = useState(true);
const [isActive2, setIsActive2] = useState(true);

const handleClose = () => {
    setOpen(false);
  };

  


  return (
      <div className='contenedorBeneficios'>
         <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={open}
                        onClick={handleClose}
                      >
                        <Alert  severity="warning" onClose={() => {}}>{refTexto.current}</Alert>

                      </Backdrop>

          <div className='acoHead' onClick={() => {
            setIsActive(!isActive)
            setTimeout(() => {
                setIsActive2(!isActive2)
          }, 700)}}>
              <div className='titAco'>Consulta los montos de recargas</div>
              <div className={isActive ? "fleUp" : "fleDown"}></div>
          </div>
          {
            isActive2 &&
            
            <div className={isActive ? "acoBody animate__animated animate__slideInDown" : "acoBody animate__animated animate__slideOutUp"} >
              <div className="montos-wrapper">
                <div className='tituloMontosB'>RECARGAS DISPONIBLES</div>
                <table className='tablamont'>
                    <tbody>
                    <tr>
                        <td className='subtitulomontos'>
                            
                              Realiza tu recarga de
                             
                        </td>
                        <td className='contenedorMontos'>
                           
                        {
                          ofertas.map( (of) => (
                                 
                                    <div className='monti' key={of.id}>
                        <div className='monti1'>Recarga</div>
                        ${of.monto}
                    </div> 
                                    )
                                )
                            }  
                   
                
                        </td>
                    </tr></tbody>
                </table>
                
                
              </div>
            </div>
          }
          
      </div>
  )
}
